import React, { useCallback } from 'react';

import jira from 'src/lib/api/jira';

import GenericAsyncSelect from './GenericAsyncSelect';

const JiraUserSelect = ({ rawRecordToOption, ...props }) => {
  const recordToOption = useCallback((u) => {
    if (rawRecordToOption) return rawRecordToOption(u);
    return {
      key: u.key,
      label: `${u.displayName}${u.emailAddress ? ` (${u.emailAddress})` : ''}`,
      account_id: u.accountId,
      email: u.emailAddress,
      name: u.name,
      icon: Object.values(u.avatarUrls || {})[0],
    };
  }, [rawRecordToOption]);

  const loadOptions = useCallback(async (name) => {
    const users = await jira.getUsers(name);
    return users.map(recordToOption);
  }, [recordToOption]);

  return (
    <GenericAsyncSelect
      loadOptions={loadOptions}
      placeholder="Start typing to search Jira User..."
      hasIcons
      {...props}
    />
  );
};

export default JiraUserSelect;
